import Plugin, { init } from "@/modules/_utils/Plugin";

class LoginApp extends Plugin {
  init() {
    const radios = document.querySelectorAll(
      'input[type=radio][name="authType"]'
    );
    let container = document.querySelector(".login__page-content");

    function changeHandler(e) {
      switch (this.value) {
        case "login--screen":
          container.classList.remove("register--screen");
          container.classList.add("login--screen");
          break;
        case "register--screen":
          container.classList.add("register--screen");
          container.classList.remove("login--screen");
          break;
      }
    }

    Array.prototype.forEach.call(radios, function(radio) {
      radio.addEventListener("change", changeHandler);
    });
  }
}

export default init(LoginApp, "login");
